import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
    StyledButtonEmail,
    StyledButtonCall
} from 'listing-details/components/Buttons/Buttons.styles';
import { StyledUserActions } from 'listing-details/components/UserActions/UserActions.styles';
import { Link, Image, Text } from '@blueprint/ui';

export const AgentProperties = styled(Link)(
    ({ theme: { mq, type, spacing } }) => css`
        display: flex;
        align-items: center;
        font-size: ${type.body};
        margin-bottom: ${spacing['16px']};

        ${mq.large} {
            display: inline-flex;
            order: 0;
            white-space: pre;
        }
    `
);

export const AgentNumber = styled(Link)(
    ({ theme: { spacing, type, mq } }) => css`
        margin: ${spacing['8px']} 0;
        font-size: ${type[6]};
        ${mq.large} {
            font-size: ${type[7]};
            margin: 0;
        }
    `
);

export const AgentHeader = styled('div')(
    ({ theme: { mq } }) => css`
        ${mq.medium} {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            position: relative;
        }
        ${mq.large} {
            position: static;
        }
    `
);

export const AgentName = styled(Text)(
    ({ theme: { mq, spacing, type } }) => css`
        font-weight: ${type.semiBold};
        ${mq.medium} {
            max-width: calc(100% - 10rem);
        }
        ${mq.large} {
            align-self: start;
            max-width: calc(66% - ${spacing['16px']});
            margin-right: ${spacing['16px']};
        }
        ${mq.extraLarge} {
            max-width: calc(60% - ${spacing['16px']});
        }
    `
);

export const AgentImageLink = styled('a')(
    ({ theme: { mq } }) => css`
        ${mq.medium} {
            flex: 1 1 100%;
            position: absolute;
            top: 0;
            right: 0;
            max-width: 9rem;
        }
        ${mq.large} {
            max-width: 34%;
            position: static;
            margin-left: auto;
        }
        ${mq.extraLarge} {
            max-width: 40%;
        }
    `
);
export const AgentImage = styled(Image)``;

export const AgentContact = styled('div')(
    ({ theme: { borderRadius, mq, colors, spacing } }) => css`
        ${mq.large} {
            order: 2;
            margin: ${spacing['8px']} 0 ${spacing['24px']} 0;
            border-radius: ${borderRadius['300']};
            background-color: ${colors['graphic-background-accent-light']};
            padding: ${spacing['16px']};
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    `
);

// TODO: refactor to card
export const AgentDetailsContainer = styled('div')(
    ({ theme: { boxShadow, mq, spacing, borderRadius, colors } }) => css`
        display: flex;
        flex-direction: column;

        background-color: ${colors['graphic-background-accent-light']};
        border-radius: ${borderRadius['300']};
        padding: ${spacing['24px']} ${spacing['16px']};
        ${StyledUserActions} {
            display: none;
        }
        ${mq.large} {
            background-color: ${colors.white};
            box-shadow: ${boxShadow['200']};
            ${StyledUserActions} {
                display: flex;
                order: 3;
            }
        }
    `
);

// TODO: alias box-shadow to fixed
export const AgentCTAs = styled('div')(
    ({ theme: { boxShadow, mq, colors, spacing, fontSizes } }) => css`
        position: fixed;
        left: 0;
        bottom: 0;
        height: 3.75rem;
        display: flex;
        align-items: center;
        background: ${colors.white};
        width: 100%;
        margin: 0;
        box-shadow: ${boxShadow['200']};
        padding: 0 ${spacing['8px']};
        z-index: 3;

        ${StyledButtonCall}, ${StyledButtonEmail} {
            font-size: ${fontSizes['1']};
            padding-left: ${spacing['4px']};
            padding-right: ${spacing['4px']};
            margin: 0 ${spacing['8px']};
        }

        ${mq.large} {
            height: auto;
            box-shadow: none;
            background: ${colors['transparent']};
            position: static;
            padding: 0;

            ${StyledButtonCall} {
                display: none;
            }

            ${StyledButtonCall}, ${StyledButtonEmail} {
                margin: 0;
                font-size: ${fontSizes['2']};
            }
        }
    `
);

export const AgentCallCTA = styled('div')(
    ({ theme: { mq, spacing, type } }) => css`
        strong {
            display: none;
        }
        ${mq.large} {
            font-size: ${type[7]};
            margin-bottom: ${spacing['8px']};
            ${AgentNumber} {
                display: inline-block;
            }
            strong {
                display: inline-block;
                margin-right: ${spacing['8px']};
            }
        }
    `
);
